module.exports = __webpack_public_path__ + "static/media/1003022.f605abb8.jpg";